import React from 'react';

const xModal = { which: null, listeners: new Set() };

export function openModal(k) { xModal.which = k; xModal.listeners.forEach(fn => fn()); }
export function closeModal() { xModal.which = null; xModal.listeners.forEach(fn => fn()); }

export function useModal() {
  const [, setT] = React.useState(0);
  React.useEffect(() => {
    const f = () => setT(t => t + 1);
    xModal.listeners.add(f);
    return () => xModal.listeners.delete(f);
  }, []);
  return xModal.which;
}
